export const rcphVersionValues = [
  /**
   * Initial version
   */
  1,
  /**
   * Addition of SECU, TAG and ECOM activities. All products now use v2 risk-carrier IDs.
   */
  2,
  /**
   * Agora migration.
   */
  3,
  /**
   * Some activity-config updates and new pricing 2.1.
   */
  3.1,
  /**
   * Require annual payment for an extra set of activities
   * from this version onwards. Behaviour is otherwise identical to 3.1.
   */
  3.2,
] as const

export type RcphVersion = (typeof rcphVersionValues)[number]
